import { render, staticRenderFns } from "./TabsDashboardMessages.vue?vue&type=template&id=2c0cbe2a&"
import script from "./TabsDashboardMessages.vue?vue&type=script&lang=js&"
export * from "./TabsDashboardMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports